<template>
  <!--steps navigator-->
  <div v-if="steps.length > 2" class="steps-navigator" :class="{'show': status, '': !status}">
    <button class="btn btn-sm btn-primary" type="button" @click="open">
      {{ $t('steps') }} ({{ currentStep.name }})
      <fa v-if="!status" icon="caret-right" />
      <fa v-else icon="caret-down" />
    </button>
    <ul>
      <li v-for="(step, index) in steps" :key="index" @click.prevent="changeCurrentStep(step.id)">
        {{ step.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    status: false
  }),
  computed: {
    ...mapGetters({
      steps: 'configurator/navigation',
      currentStep: 'configurator/currentStep'
    })
  },
  methods: {
    ...mapActions({
      setCurrentStep: 'configurator/setCurrentStep'
    }),
    open () {
      this.status = !this.status
    },
    changeCurrentStep (id) {
      this.$root.$refs.loading.start()
      this.setCurrentStep(id)
      this.status = false
      this.$root.$refs.loading.finish()
    }
  }
}
</script>
